import { CoreInfoCard } from 'components/cards'
import { lightningSVG } from '../../../../assets/svg/lightning'
import { useDashboardTranslation } from '../../../../hooks/translation/useDashboardTranslation'
import { ChargerInfo } from '../../../../models/chargerv2'
import { HomePageChargersParticpatingInDemandResponseEventsChart } from '../../charts/active-users/chargers-participating-demand-response-events'
import { useNavigateToChargers } from '../../../../hooks/useNavigateToChargers'
import { TenantRef } from '../../../../models/tenant'
import { MasterAccountRef } from '../../../../models/master-account'

interface props {
  chargerInfo: ChargerInfo | undefined
  wsLoading: boolean
  tenants?: TenantRef[]
  masterAccounts?: MasterAccountRef[]
}

const ConnectorInServiceCard: React.FC<props> = ({ chargerInfo, wsLoading, tenants, masterAccounts }) => {
  const { goToTroubleshootingChargers, goToUnderRepairChargers } = useNavigateToChargers(masterAccounts, tenants)

  const {
    chargersEnrolledInDemandResponseText,
    troubleshootingText,
    underRepairText,
  } = useDashboardTranslation()
  const troubleshootingCount = (chargerInfo?.chargers.troubleshooting ?? 0)
  const underRepairCount = (chargerInfo?.chargers.repair ?? 0)
  const activeCount = (chargerInfo?.chargers.active ?? 0)
  const totalCount = (chargerInfo?.chargers.total ?? 0)
  
  const infoDetails = [
    {
      label: troubleshootingText,
      subLabel: troubleshootingCount.toLocaleString(),
      onClick: goToTroubleshootingChargers,
    },
    {
      label: underRepairText,
      subLabel: underRepairCount.toLocaleString(),
      onClick: goToUnderRepairChargers,
    },
  ]

  const infoTextFormatter = (infoText: JSX.Element, scale: number = 1) => (
    <>
      {infoText}
      <div className="suffix" style={{ transform: `scale(${scale})` }}>
        <p className="paragraph-01-regular">
          Active of {totalCount.toLocaleString()}
        </p>
      </div>
    </>
  )

  return (
    <CoreInfoCard
      title={chargersEnrolledInDemandResponseText}
      wsLoading={wsLoading}
      infoText={activeCount.toLocaleString()}
      infoTextFormatter={infoTextFormatter}
      chargerInfoChart={
        chargerInfo && <HomePageChargersParticpatingInDemandResponseEventsChart chargerInfo={chargerInfo} />
      }
      overviewIcon={lightningSVG}
      infoDetails={chargerInfo && chargerInfo.chargers && infoDetails}
    />
  )
}

export default ConnectorInServiceCard

